import React, { Component } from 'react';
import { Row, Col } from 'antd';
import "./style.css"
import logoGoogle from "./../../assets/images/google.png"
import logoFirefox from "./../../assets/images/firefox.png"
import logoEdge from "./../../assets/images/edge.png"
import logoIe from "./../../assets/images/ie.png"

class App extends React.Component {
    render() {
        return (
            <div className="compatible">
                <p style={{ fontSize: "22px", color: "#333" }}>
                    江苏省“智慧315”综合服务平台
                </p>
                <p className="compatiblePrompt">本平台不支持您所使用的浏览器，请尝试其他浏览器！</p>
                <p style={{ lineHeight: "80px", color: "#000", fontSize:18 }}>您可以通过以下浏览器进行访问：</p>
                <div style={{ textAlign:"center" }}>
                    <Row>
                        <Col span={2}>
                            <img src={logoGoogle} alt="" />
                            <div>谷歌浏览器</div>
                        </Col>
                        <Col span={2}>
                            <img src={logoFirefox} alt="" />
                            <div>火狐浏览器</div>
                        </Col>
                        <Col span={2}>
                            <img src={logoIe} alt="" />
                            <div>IE浏览器</div>
                            <div style={{ color: "#f00" }}>注：版本11以上</div>
                        </Col>
                        <Col span={2}>
                            <img src={logoEdge} alt="" />
                            <div>Edge浏览器</div>
                        </Col>
                        <Col span={3} style={{ textAlign:"left" }}>
                            <img src={logoFirefox} alt="" />
                            <div>360安全浏览器</div>
                            <div>360极速浏览器</div>
                            <div>QQ浏览器</div>
                            <div>百度浏览器</div>
                            <div>UC浏览器</div>
                            <div style={{color:"#f00"}}>注：如依旧无法打开,</div>
                            <div style={{ color: "#f00" }}>请切换至极速模式</div>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}

export default App


// WEBPACK FOOTER //
// ./src/components/Compatible/Compatible.js